import { useCallback, useEffect, useState } from "react";
import { listDecisions } from "@/lib/decisionStore";
import { listSheets, todayJakarta, jakartaDay } from "@/lib/sheetStore";
import { pickAttention } from "@/lib/attentionOrder";
export { pickAttention } from "@/lib/attentionOrder";

// ?state=loading|error memaksa keadaan untuk QA.
export function useAttention() {
  const [state, setState] = useState("loading");
  const [pins, setPins] = useState([]);
  const [sheetRow, setSheetRow] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const forced = new URLSearchParams(window.location.search).get("state");
    if (forced === "loading") return undefined;
    let live = true;
    setState("loading");
    Promise.all([listDecisions(), listSheets()]).then(([res, sheetsRes]) => {
      if (!live) return;
      if (res.error || (forced === "error" && attempt === 0)) return setState("error");
      const picked = pickAttention(res.decisions);
      setPins(picked);
      const today = todayJakarta();
      setSheetRow(
        sheetsRes.sheets?.find((s) => s.status === "open" && jakartaDay(s.updatedAt) === today) ?? null,
      );
      setState(picked.length ? "ready" : "empty");
    });
    return () => {
      live = false;
    };
  }, [attempt]);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);
  return { state, pins, sheetRow, retry };
}
